import firebase from 'firebase/app';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { createTokenCookie } from '../../api/sso';
import { useCurrentUser } from '../../redux/selectors/authSelectors';

interface AuthManagerProps {}
const AuthManager: React.FC<AuthManagerProps> = () => {
  const user = useCurrentUser();

  const [email, setEmail] = React.useState<string>('');
  const [pw, setPw] = React.useState<string>('');

  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const navigate = useNavigate();

  const onLogin = () => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, pw)
      .then(async cred => {
        const token = await cred?.user?.getIdToken(true);
        if (token) {
          await createTokenCookie(token);
        }
      })
      .catch(error => {
        setErrorMessage(error.message);
      });
  };

  const onLogout = () => {
    navigate('/');
  };

  return (
    <AuthManagerWrapper>
      {user === null ? (
        <>
          <p>Log in</p>
          <input onChange={e => setEmail(e.target.value)} value={email} />
          <input onChange={e => setPw(e.target.value)} value={pw} />
          <button onClick={() => onLogin()}>Log in</button>

          {errorMessage !== '' && <p>Error: {errorMessage}</p>}
        </>
      ) : (
        <>
          <p>Hello {user.displayName || '[No Name]'}!</p>
          <button onClick={() => onLogout()}>Log out</button>
        </>
      )}
    </AuthManagerWrapper>
  );
};

const AuthManagerWrapper = styled.div`
  padding: 1rem 3rem;
  border: 1px solid #ccc;
`;

export default AuthManager;
